<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 32,
      height: 32,
      color: 'currentColor',
      viewBoxValue: `0 0 33 32`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <g id="check-verified-03">
      <path
        id="Icon"
        d="M12.8026 16L15.4692 18.6667L21.4692 12.6667M13.0718 27.4678C13.5088 27.4101 13.9502 27.5286 14.2983 27.7967L15.9026 29.0278C16.433 29.4352 17.1707 29.4352 17.6995 29.0278L19.3646 27.7493C19.6757 27.5108 20.0682 27.4056 20.4563 27.4575L22.5391 27.7315C23.2013 27.8189 23.8398 27.4501 24.096 26.8323L24.8975 24.8946C25.0471 24.5316 25.3345 24.2442 25.6974 24.0946L27.635 23.2931C28.2527 23.0383 28.6216 22.3983 28.5342 21.7361L28.2705 19.7288C28.2127 19.2918 28.3312 18.8503 28.5994 18.5022L29.8304 16.8978C30.2377 16.3674 30.2377 15.6296 29.8304 15.1008L28.552 13.4356C28.3135 13.1245 28.2083 12.7319 28.2601 12.3438L28.5342 10.2609C28.6216 9.59869 28.2527 8.96019 27.635 8.7039L25.6974 7.90244C25.3345 7.75282 25.0471 7.46542 24.8975 7.10247L24.096 5.16474C23.8412 4.54698 23.2013 4.1781 22.5391 4.26551L20.4563 4.53957C20.0682 4.59291 19.6757 4.48772 19.3661 4.25069L17.701 2.97221C17.1707 2.56482 16.433 2.56482 15.9041 2.97221L14.2391 4.25069C13.928 4.48772 13.5354 4.59291 13.1473 4.54254L11.0645 4.26847C10.4024 4.18107 9.7639 4.54995 9.50762 5.16771L8.70769 7.10543C8.55659 7.4669 8.26921 7.7543 7.90776 7.90541L5.97014 8.70539C5.35241 8.96168 4.98356 9.60018 5.07096 10.2624L5.34501 12.3453C5.39537 12.7334 5.2902 13.126 5.05318 13.4356L3.77477 15.1008C3.36739 15.6311 3.36739 16.3689 3.77477 16.8978L5.05318 18.5629C5.29168 18.874 5.39686 19.2666 5.34501 19.6547L5.07096 21.7376C4.98356 22.3998 5.35241 23.0383 5.97014 23.2946L7.90776 24.0961C8.27069 24.2457 8.55807 24.5331 8.70769 24.896L9.50911 26.8338C9.7639 27.4515 10.4038 27.8204 11.066 27.733L13.0718 27.4678Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </IconBase>
</template>

<style scoped lang="scss"></style>
